export const getMotivoDelRetiro = () => {
  return [
    { key: "1", name: "Voluntario" },
    { key: "2", name: "Despido" },
    { key: "3", name: "Finalización de contrato" },
    { key: "4", name: "Ascenso" },
    { key: "5", name: "Cambio de regional" },
  ];
};

export const getMotivoDeSolicitud = () => {
  return [
    { key: "1", name: "Reemplazo" },
    { key: "2", name: "Cambio de cargo" },
    { key: "3", name: "Nuevo cargo" },
    { key: "4", name: "Licencia" },
    { key: "5", name: "Aumento de planta" },
  ];
};

export const getState = () => {
  return [
    { key: "1", name: "ACTIVO" },
    { key: "2", name: "INACTIVO" },
  ];
};

export const getRequisitionState = () => {
  return [
    { key: "EN_ELABORACION", name: "En Elaboración" },
    { key: "PENDIENTE_POR_APROBACION", name: "Pendiente Por Aprobación" },
    { key: "APROBADO", name: "Aprobado" },
    { key: "RECHAZADO", name: "Rechazado" },
    { key: "ANULADO", name: "Anulado" },
    { key: "PUBLICADO", name: "Publicado" },
    { key: "CERRADA", name: "Cerrada" },
  ];
};


export const getRequisitionManageState = () => {
  return [
    { key: "PENDIENTE_POR_APROBACION", name: "Pendiente Por Aprobación" },
    { key: "APROBADO", name: "Aprobado" },
    { key: "RECHAZADO", name: "Rechazado" },
    { key: "PUBLICADO", name: "Publicado" },
    { key: "CERRADA", name: "Cerrada" },
  ];
};

export const getPermissionStates = () => {
  return [
    { key: "PENDIENTE_POR_APROBACION", name: "Pendiente Por Aprobación" },
    { key: "PRE_APROBADA", name: "Pre Aprobado" },
    { key: "APROBADA", name: "Aprobado" },
    { key: "RECHAZADA", name: "Rechazado" },
    { key: "ANULADA", name: "Anulado" }
  ];
};

export const getTipoDeContrato = () => {
  return [
    { key: "CONTRATO_DE_APRENDIZAJE", name: "Contrato De Aprendizaje" },
    { key: "CONTRATO_POR_OBRA_LABOR", name: "Contrato Por Obra Labor" },
    {
      key: "CONTRATO_PRESTACION_DE_SERVICIO",
      name: "Contrato Prestación de Servicio",
    },
    { key: "CONTRATO_TERMINO_FIJO", name: "Contrato Término Fijo" },
    { key: "CONTRATO_TERMINO_INDEFINIDO", name: "Contrato Término Indefinido" },
  ];
};

export const getOpcionesInicioContrato = () => {
  return [
    { key: "FAVORABLE", name: "Favorable" },
    { key: "NO_FAVORABLE", name: "No Favorable" },
    {
      key: "FAVORABLE_CON_RECOMENDACIONES",
      name: "Favorable con recomendaciones",
    },
  ];
};

export const getTypeIdentificationDocument = () => {
  return [
    { key: "1", name: "Cédula de Ciudadanía (CC)" },
    { key: "2", name: "Tarjeta de Identidad (TI)" },
    { key: "3", name: "Registro Civil (RC)" },
    { key: "4", name: "Adulto sin Identificar (AS)" },
    { key: "5", name: "Menos sin Identificar (MS)" },
    { key: "6", name: "Cédula de extranjería" },
    { key: "7", name: "Pasaporte (PA)" },
    { key: "8", name: "Carnét Diplomático (CD)" },
    { key: "8", name: "Salvo Conducto (SC)" },
    { key: "10", name: "Permiso Especial de Permanencia (PE)" },
    { key: "11", name: "Documento Extrangero (DE)" },
  ];
};

export const getIdentificationType = () => {
  return [
    { key: "Registro Civil", name: "Registro Civil" },
    { key: "Tarjeta de Identidad", name: "Tarjeta de Identidad" },
    { key: "Cédula de ciudadanía", name: "Cédula de ciudadanía" },
    { key: "Cédula de extranjería", name: "Cédula de extranjería" },
    { key: "Pasaporte", name: "Pasaporte" },
  ];
};

export const getLocations = () => {
  return [
    { key: "1", name: "Regional Bolívar Norte" },
    { key: "2", name: "Regional Bolívar Centro" },
    { key: "3", name: "Regional Barranquilla" },
    { key: "4", name: "Regional Sincelejo" },
    { key: "5", name: "Regional Montería" },
    { key: "6", name: "Regional Santa Marta" },
    { key: "7", name: "Regional Banco" },
  ];
};

export const getCarrers = () => {
  return [
    { id: "ad69ccf3-a363-4459-9529-0574b118e319", label: "Ingeniero Sistemas" },
    {
      id: "ad69ccf3-a363-4459-9529-0574b118e318",
      label: "Ingeniero Electrico",
    },
    { id: "ad69ccf3-a363-4459-9529-0574b118e317", label: "Medico General" },
    { id: "ad69ccf3-a363-4459-9529-0574b118e316", label: "Enfermero Jefe" },
    { id: "ad69ccf3-a363-4459-9529-0574b118e315", label: "Enfermero General" },
    { id: "ad69ccf3-a363-4459-9529-0574b118e314", label: "Odontologo" },
    { id: "ad69ccf3-a363-4459-9529-0574b118e313", label: "Internista" },
  ];
};

export const rawContent = {
  blocks: [],
  entityMap: {},
};

export const getPostulateStatusValues = () => {
  return [
    { key: "IN_PROCESS", name: "En Proceso" },
    { key: "POSTULATE", name: "Postulado" },
    { key: "PRESELECTED", name: "Preseleccionado" },
    { key: "REJECTED", name: "Rechazado" },
    { key: "SELECTED", name: "Seleccionado" },
  ];
};